import React from 'react'
import { Form, Alert } from 'react-bootstrap'
import TokenDisplay from '../components/TokenDisplay'
import AmountInput from '../components/AmountInput'
import { ShieldIconSvg } from '../../../assets/svg'

const ApprovalStep = ({
    isShielding,
    actionText,
    approveError,
    selectedToken,
    amount,
    useMaxAmount,
    handleAmountChange,
    handleMaxClick,
    getAmountError
}) => {
    return (
        <>
            {/* Step Description */}
            <div
                className="card mb-3"
                // style={{ backgroundColor: '#f8f9fa', border: '1px solid #e9ecef' }}
            >
                <div className='card-body p-3'>
                    <h6 className="fw-bold mb-2 d-flex align-items-center gap-2">
                        <ShieldIconSvg width={20} height={20} />
                        {isShielding ? 'Shield Assets into Private Balance' : 'Unshield Assets into Public Balance'}
                    </h6>
                    <p className="small mb-0">
                        {isShielding
                            ? 
                            <div className=''>
                                <p className='mb-2'>Shielding moves tokens from your public mode 0x address into the private Kaxaa eWallet pool.</p>
                            </div>
                            : 
                            <div className=''>
                                <p className='mb-2'>Unshielding moves tokens from your private mode 0x address into your public Kaxaa eWallet pool.</p>
                            </div>
                        }
                    </p>
                </div>
            </div>

            {approveError && (
                <Alert variant="danger" className="mb-3">
                    <strong>⚠️ Approval Failed:</strong> {approveError}
                </Alert>
            )}

            <Form>
                <TokenDisplay selectedToken={selectedToken} actionText={actionText} />

                <AmountInput
                    isShielding={isShielding}
                    amount={amount}
                    useMaxAmount={useMaxAmount}
                    selectedToken={selectedToken}
                    onAmountChange={handleAmountChange}
                    onMaxClick={handleMaxClick}
                    getAmountError={getAmountError}
                />
            </Form>
        </>
    )
}

export default ApprovalStep
